<script setup>
import Breadcrumb from 'dashboard/components-next/breadcrumb/Breadcrumb.vue';

defineProps({
  breadcrumbItems: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['breadcrumbClick']);
</script>

<template>
  <section
    class="flex h-full w-full flex-col overflow-hidden bg-auth-canvas text-auth-text dark:bg-auth-canvas-dark dark:text-auth-text-dark"
  >
    <header
      class="sticky top-0 z-20 border-b border-auth-border bg-auth-canvas/95 px-3 dark:border-auth-border-dark dark:bg-auth-canvas-dark/95 sm:px-5 lg:px-6"
    >
      <div
        class="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 py-4 sm:py-5 [&_button]:focus-visible:outline [&_button]:focus-visible:outline-2 [&_button]:focus-visible:outline-offset-2 [&_button]:focus-visible:outline-auth-action dark:[&_button]:focus-visible:outline-auth-accent"
      >
        <Breadcrumb
          :items="breadcrumbItems"
          @click="(item, index) => emit('breadcrumbClick', item, index)"
        />
      </div>
    </header>
    <main class="flex-1 overflow-y-auto px-3 sm:px-5 lg:px-6">
      <div class="mx-auto w-full max-w-7xl pb-8 pt-4">
        <slot />
      </div>
    </main>
  </section>
</template>
